<div class="container">
  <h1 class="mt-5" i18n="@@order-confirmation.order-performed">Beställning utförd</h1>

  <p i18n="@@order-confirmation.information">
    Vi har mottagit din beställning och kommer återkoppla snarast möjligt.
  </p>

  <div class="bs-callout-info mb-3" [routerLink]="orderLink" (keyup.enter)="navigateToOrder()">
    <div id="openOrderToActivate" class="title" i18n="@@order-confirmation.order-id">
      Beställningsnummer
    </div>
    <div>{{ orderId }}</div>
    <div *ngIf="referenceId" class="title" i18n="@@order-confirmation.reference">Referens</div>
    <div>{{ referenceId }}</div>
  </div>

  <hr />

  <p i18n="@@order-confirmation.questions">Vid frågor kontakta</p>

  <div *ngIf="isCtlSweden">
    <div class="mt-2"><a href="tel:+46102006503" target="_top">+46 10-200 65 03</a></div>
    <div class="mt-2 mb-5">
      <a href="mailto:trafikledning.extratrafik@nobina.se" target="_top"
        >trafikledning.extratrafik@nobina.se</a
      >
    </div>
  </div>

  <div *ngIf="isCtlNorway">
    <div class="mt-2"><a href="tel:+4741343994" target="_top">+47 413-43 994</a></div>
    <div class="mt-2 mb-5">
      <a href="mailto:kommersielltrafikk@nobina.no" target="_top">kommersielltrafikk@nobina.no</a>
    </div>
  </div>

  <div *ngIf="isCtlFinland">
    <div class="mt-2 mb-5">
      <a href="mailto:jarkko.pesonen@nobina.fi" target="_top">jarkko.pesonen@nobina.fi</a>
    </div>
  </div>

  <div *ngIf="isCtlDenmark">
    <div class="mt-2 mb-5">
      <a href="mailto:stig.amlund@nobina.dk" target="_top">stig.amlund@nobina.dk</a>
    </div>
  </div>

  <div *ngIf="isNoCtl">
    <div class="mt-3" i18n="@@order-confirmation.no-contact-details">
      Ingen kontaktinfo finns än.
    </div>
  </div>
</div>
